import React from "react";
import { useNewLayout } from "store/selectors/hooks";

interface Props {
    additionalClassName?: string;
}

export const InputFormBlock: React.FC<React.PropsWithChildren<Props>> = props => {
    const { children, additionalClassName } = props;
    const newLayout = useNewLayout();
    if (newLayout) {
        return (
            <div
                className={`p-1 mb-4 lg:mb-0 md:p-4 bg-white lg:shadow rounded ring-gray-200 lg:ring-1 ${
                    additionalClassName ?? ""
                }`}>
                {children}
            </div>
        );
    }
    return (
        <div
            className={`input-form-block-no-bottom-margin ${additionalClassName ?? ""} `}>
            {children}
        </div>
    );
};
